import { chunk } from 'lodash';

import { UUID_BATCH_SIZE } from 'constants/cache/accountUsersCache';

import { getUsersUuidsWithRetry } from './getUsersUuidsWithRetry';

/**
 * Resolves UUIDs for any number of user PKs by splitting them into Cloud-sized batches.
 *
 * The `legacy_id_mapping` call accepts at most UUID_BATCH_SIZE ids per request, so the PKs are
 * chunked and each batch is fetched with retry. A batch that ultimately fails is skipped (its PKs
 * stay unresolved) instead of failing the whole call, so a partial outage still yields the pairs we
 * could get.
 *
 * @param {Array<string|number>} ids - User PKs (PK_User) to resolve.
 * @returns {Promise<Object>} Map of PK_User → UUID for the batches that succeeded (may be empty).
 */
export const getUsersUuidsInBatches = async (ids) => {
    if (!ids.length) {
        return {};
    }

    const batches = chunk(ids, UUID_BATCH_SIZE);
    const results = await Promise.all(batches.map((batch) => getUsersUuidsWithRetry(batch).catch(() => ({}))));

    return Object.assign({}, ...results);
};
